import {
  init_utils
} from "./chunk-SBNKSDBP.mjs";
import {
  cn
} from "./chunk-CVRFJC2Q.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/components/label/label.tsx
init_utils();
import * as LabelPrimitives from "@radix-ui/react-label";
import React from "react";
var Label = React.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React.createElement(
    LabelPrimitives.Root,
    __spreadProps(__spreadValues({
      className: cn("text-foreground my-label-xs", className)
    }, props), {
      ref
    })
  );
});

export {
  Label
};
